import { defineComponent as _defineComponent } from 'vue';
import { BButton, BFormInput, BInputGroup, BInputGroupAppend } from "bootstrap-vue";
import { computed, ref } from "vue";
import { markup } from "@/components/ObjectStore/configurationMarkdown";
export default /*#__PURE__*/ _defineComponent({
    __name: 'VaultSecret',
    props: {
        name: null,
        label: null,
        help: null,
        isSet: { type: Boolean }
    },
    emits: ["update"],
    setup(__props, { emit }) {
        const props = __props;
        const showEdit = ref(false);
        const secretValue = ref("");
        const editTitle = computed(() => `Edit ${props.label}`);
        const helpHtml = computed(() => markup(props.help, true));
        function onClick() {
            showEdit.value = true;
        }
        async function onOk() {
            emit("update", props.name, secretValue.value);
        }
        return { __sfc: true, props, showEdit, secretValue, editTitle, helpHtml, onClick, emit, onOk, BButton, BFormInput, BInputGroup, BInputGroupAppend };
    }
});
